import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Grid, Table, Alert, Snackbar, tableCellClasses, Button, Box, IconButton, InputLabel, Select, MenuItem, FormControl } from '@mui/material';
import { z } from "zod";
import { FormModal, RHFTextField } from "../components/form";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import api, { fetchDispatchRepairReplacements, updateDispatchRepairReplacement, emailDispatchRepairReplacementPdf, generateDispatchRepairReplacementPdf } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import DataTable from '../components/DataTable';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';

export function StoreRepairReplacement() {
    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
    const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};

    const fetchTrucks = async () => {
        try {
            const response = await fetchDispatchRepairReplacements();
            setStoreData(response.data);
            showSnackbar('Store fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching Store';
            showSnackbar(`Failed to fetch Store: ${errorMessage}`, 'error');
        }
    };
    const handleSendEmail = async (saleId) => {
        try {
            await emailDispatchRepairReplacementPdf(saleId, {});
            alert("Email sent successfully!");
        } catch (error) {
            console.error("Email error:", error);
            alert("Failed to send email.");
        }
    };

    React.useEffect(() => {
        fetchTrucks();
    }, []);
    const handleSendToOtherDepartment = async (saleId) => {
        try {
            const response = await generateDispatchRepairReplacementPdf(saleId);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `StoreRecord_${saleId}.pdf`;
            a.click();
        } catch (error) {
            console.error('Error:', error);
            console.error('Failed to generate PDF');
        }
    };
    const showSnackbar = (message, severity) => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const [storeData, setStoreData] = React.useState([])
    const [modalOpen, setModalOpen] = React.useState(false);
    // Save storeData to localStorage on update
    React.useEffect(() => {
        localStorage.setItem('store', JSON.stringify(storeData));
        console.log(storeData, 'storeData');

    }, [storeData]);

    const handleOpen = () => setModalOpen(true);
    const handleClose = () => setModalOpen(false);
    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const [selectedStore, setSelectedStore] = React.useState(null);
    const handleEditOn = (device) => {
        setSelectedStore(device);
        setEditModalOpen(true);
    };

    const handleEditClose = () => {
        setEditModalOpen(false);
        setSelectedStore(null);
    };
const handleStatusChange = async (saleId, newStatus, sale) => {
    const updatedSale = { ...sale, status: newStatus };

    try {
        await updateDispatchRepairReplacement(saleId, updatedSale);

        // Update state in frontend
        setStoreData((prevData) =>
            prevData.map((item) =>
                item.id === saleId ? { ...item, status: newStatus } : item
            )
        );

        showSnackbar('Status updated successfully', 'success');
    } catch (error) {
        console.error('Failed to update status:', error);
        showSnackbar('Failed to update status', 'error');
    }
};
    const handleDelete = async (id) => {
        try {
            await api.delete(`/dispatch-repair-replacement/${id}/`);
            showSnackbar("Customer deleted successfully", "success");
        } catch (error) {
            showSnackbar("Failed to delete customer", "error");
            console.error(error);
        }
    };

    const handleSave = async (newEmployee) => {
        try {
            const response = await api.post('/dispatch-repair-replacement/', newEmployee);
            setStoreData((prev) => [...prev, response.data]);
        } catch (error) {
            console.error("Error saving employee:", error);
        }
    };

    const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a3');

  // Title
  doc.setFontSize(18);
  doc.text('Store Repair Replacement Report', 14, 16);

  // Table Headers (match your UI table, excluding "Action")
  const columns = [
    'Store #',
    'Remarks',
    'Closed At',
  ];

  // Table Data
  const tableData = storeData.map(record => [
    record.id,
    record.remarks || '',
    record.status === "Close"
      ? record.updated_at?.slice(0, 19).replace("T", " ")
      : "",
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 2,
    },
    columnStyles: {
      0: { cellWidth: 40 },  // Store #
      1: { cellWidth: 100 }, // Remarks (more space for text)
      2: { cellWidth: 50 },  // Closed At
    },
    theme: 'grid',
    didDrawPage: function () {
      doc.setFontSize(18);
      doc.text('Store Repair Replacement Report', 14, 16);
    },
  });

  doc.save('Store_Repair_Replacement_Report.pdf');
};
    const EditStoreModal = ({ open, handleClose, device }) => (
        <FormModal
            open={open}
            onClose={handleClose}
            title="Edit Store"
            schema={z.object({ remarks: z.string().optional() })}
            defaultValues={{ remarks: device?.remarks ?? "" }}
            onSubmit={async (data) => {
                const payload = new FormData();
                Object.entries(data).forEach(([k, v]) => {
                    if (v !== null && v !== undefined && v !== "") payload.append(k, v);
                });
                try {
                    await updateDispatchRepairReplacement(device.id, payload);
                    showSnackbar("Store updated successfully", "success");
                    fetchTrucks();
                } catch (err) {
                    showSnackbar("Store update failed", "error");
                    throw err;
                }
            }}
            submitLabel="Update"
            width={400}
        >
            {({ control }) => (
                <>
                    <Box sx={{ mb: 2, display: "flex", gap: 3, flexWrap: "wrap" }}>
                        <Typography variant="body2" color="text.secondary">
                            Updated At: {device?.updated_at?.slice(0, 19).replace("T", " ")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Created At: {device?.created_at?.slice(0, 19).replace("T", " ")}
                        </Typography>
                    </Box>
                    <Grid container spacing={2.5}>
                        <Grid item xs={12}>
                            <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={3} />
                        </Grid>
                    </Grid>
                </>
            )}
        </FormModal>
    );

    const updateStore = async (updatedStore, id) => {
        const formData = new FormData();
        for (const key in updatedStore) {
            formData.append(key, updatedStore[key]);
        }
        try {
            await updateDispatchRepairReplacement(id, formData);
            showSnackbar('Store updated successfully', 'success');
        } catch (error) {
            showSnackbar('Failed to update device', 'error');
        }
    };
    return (
        <Container maxWidth="xl" sx={{ m: 2 }}>
            {editModalOpen && selectedStore && <EditStoreModal
                open={editModalOpen}
                handleClose={handleEditClose}
                device={selectedStore}
            />}
            <DataTable
                title="Store Repair/Replacement List"
                columns={[
                    { key: 'id', label: 'Store #' },
                    { key: 'remarks', label: 'Remarks' },
                    { key: 'close_at', label: 'Close At', render: (sale) => (
                        <div style={{ maxHeight: '80px', overflow: 'auto' }}>{sale.status === 'Close' && sale.updated_at?.slice(0, 19).replace("T", " ")}</div>
                    )},
                ]}
                rows={storeData}
                toolbarActions={<Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>}
                renderActions={(sale) => <>
                    <IconButton color="secondary" size="small" onClick={() => handleEditOn(sale)} sx={{ padding: '6px' }} disabled={sale.status === 'Close'}><EditIcon /></IconButton>
                    <IconButton color="error" size="small" onClick={() => handleDelete(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sale.status === 'Close'}><DeleteIcon /></IconButton>
                    <IconButton color="primary" size="small" onClick={() => handleSendEmail(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }}><SendIcon /></IconButton>
                    <Select value={sale.status} onChange={(e) => handleStatusChange(sale.id, e.target.value, sale)} size="small" sx={{ ml: 1, minWidth: 100 }}>
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Complete">Complete</MenuItem>
                    </Select>
                </>}
            />
                {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}
